(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-related-products"] && !Shopify.designMode) return;
  try {
    
  const recommendedProductsCard = document.querySelectorAll(".recommendations-section .product-card,.shopify-section--recently-viewed-products .product-card");
      if (recommendedProductsCard.length) {
        recommendedProductsCard.forEach((productCard) => {
          var sizeElem = productCard.querySelector(".related_variant-picker .size");
          
          if (sizeElem) {
            sizeElem.addEventListener('click', function () {
              recommendedProductsCard.forEach((card) => {
                if (card !== productCard) {
                  let otherSizeElem = card.querySelector(".related_variant-picker .size");
                  if (otherSizeElem) {
                    otherSizeElem.classList.remove('active');
                  }
                }
              });
              sizeElem.classList.toggle('active');
            });
          }

          var sizeTypes = productCard.querySelectorAll(".related_variant-picker .size-label-add");
          if(sizeTypes.length){
            sizeTypes.forEach((sizeType)=>{
              sizeType.addEventListener('click',function(){
                var selected_value = sizeType.getAttribute("data-value");
                productCard.querySelector(".sizes-wrapper .selected_value").textContent = selected_value;

                var variantId = sizeType.getAttribute("data-variant");
                var originalPrice = sizeType.getAttribute("data-original-price");
                productCard.querySelector("input[name='id']").value = variantId;
                productCard.querySelector("input[name='properties[_Originalprice]']").value = originalPrice;
              });
            });
          }
        });
      }

  } catch(e) { console.error(e); }
})();
})();
